import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import LoanListPageUI from './LoanListPageUI.js'

class RepaidLoanListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loanList: null,
      fundSourceList: null,
    }
  }

  render() {
    return (
      <LoanListPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        fundSourceList={this.state.fundSourceList}
        loanList={this.state.loanList}
        onRefreshClick={this.onRefreshClick}
        onTypeChange={this.onTypeChange}
        openOrClosed='repaid'
        pageTitle='Repaid loans'
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    const queryParameters = new URLSearchParams(window.location.search)
    this.getLoans(context, context.filter)
  }

  onTypeChange = (type) => {
    this.getLoans(this.props.context, type)
  }

  getLoans(context, stp) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans`,
      cacheKey: CacheKeys.AllLoans('repaid', stp),
      callback: this.getLoansCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context, {}, { openOrClosed: 'repaid', stp: stp === 'stp' ? true : false })
  }

  getLoansCallback = (response) => {
    this.setState({ errorList: response.errorList, loanList: response.loanList, fundSourceList: response.fundSourceList })
  }

  onRefreshClick = () => {
    /*
    this.state.loanList.forEach(loan => {
      CacheManager.removeObject(CacheKeys.BillsByLoanId(loan.loanId))
      CacheManager.removeObject(CacheKeys.Orders(loan.loanId, ''))
      if (loan.termSheet)
        CacheManager.removeObject(CacheKeys.Order(loan.termSheet.estimateId))
    })
    */
    CacheManager.removeObject(CacheKeys.AllLoans('repaid', this.props.context.filter))
    this.setState({ loanList: null, errorList: null })
    this.getLoans(this.props.context, this.props.context.filter)
  }
}

export default RepaidLoanListPageSF
